var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclesfaq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 24.4159C41.8545 29.297 37.8907 33.602 33.2821 37.1426C26.071 42.4685 18.7212 46.2727 11.3021 44.6127C9.01401 44.1285 5.33912 41.6385 5.75515 35.9668C6.17117 30.0876 9.63804 24.6926 10.0541 24.3468C10.0541 24.3468 5.13111 31.6784 8.38997 36.1743C11.7875 40.8776 21.4947 35.7593 23.0895 34.6526C23.0895 34.6526 29.8152 30.2951 33.3514 24.3468L45.0001 24.4159Z",
    fill: "#3E0056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.6129C3.14562 15.7319 7.10941 11.4269 11.718 7.88621C18.9291 2.62952 26.2096 -1.31299 33.698 0.416181C35.9861 0.900349 39.661 3.39036 39.245 9.06205C38.829 14.9412 35.3621 20.3363 34.9461 20.6821C34.9461 20.6821 39.869 13.3504 36.6102 8.85455C33.2126 4.1512 23.5054 9.26955 21.9106 10.3762C21.9106 10.3762 15.1849 14.7337 11.6487 20.6821L0 20.6129Z",
    fill: "#3E0056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesfaq);
export default __webpack_public_path__ + "static/media/circlesfaq.9668cc8459e0d1eb1f70a651edc5e7b9.svg";
export { ForwardRef as ReactComponent };